package floris.graphics.models.dto.requests.user

const val MIN_PASSWORD_LENGTH = 8

val String.isPasswordStrong: Boolean
    get() = this.length >= MIN_PASSWORD_LENGTH && this.contains(Regex("[A-Z]"))

interface PasswordAble {

    val password: String
    val repeatPassword: String?

    val isPasswordSame get() = password == repeatPassword

    // Password should at least be 8 characters long AND should contain at least 1 capital letter
    val isPasswordStrong get() = password.isPasswordStrong
}

interface NameAble {

    val fullName: String?
}